import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/layouts/default.vue"))
}